import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import createHistory from 'history/createBrowserHistory'

class MenuSec extends Component {
  state = {
    pathES: '',
    pathEN: '',
    isLoading: false
  }

  // Switch languages
  switchLang() {
    const history = createHistory();
    const slug = history.location.pathname;

    if (slug === '/' || slug === '/en' || slug === '/en/') {
      this.setState(() => {
        return {
          pathES: '/',
          pathEN: '/en'
        }
      })
    }
  }

  componentDidMount() {
    this.switchLang();
  }

  componentWillReceiveProps() {
    this.switchLang();
  }

  render() {
    return (
      <nav id="js-menu-sec" className={`menu-sec ${this.props.isActive ? 'menu-sec-active' : ''}`}>
        <div className="columns is-marginless is-paddingless is-mobile">

          <div className="column is-marginless is-paddingless">
            <ul className="idiomas">
              <div>
                <li><NavLink activeClassName="active" to={this.state.pathES} exact>ES</NavLink></li>
                <li><NavLink to={this.state.pathEN}>EN</NavLink></li>
              </div>
            </ul>
          </div>

          <div className="column is-marginless is-paddingless">
            <a href="https://www.facebook.com/TantaPeru/" className="icon-fb"><i className="fa fa-facebook"></i></a>
          </div>

        </div>
      </nav>
    )
  }
}

export default MenuSec;
